<template>
  <v-container fluid v-resize="onResize" ref="vueplotlyContainer">

    <v-layout justify="center">
      <v-flex cols="12">
        <v-layout v-show="input_points.length > 0" row wrap justify-center>
          <VuePlotly
              @click="openResource"
              :watchShallow="true"
              :data="data"
              :layout="layout"
              :options="options"
              ref="vueplotly"
          >
          </VuePlotly>
        </v-layout>

        <v-layout class="no-trend-yet" v-show="!input_points.length > 0" row wrap justify-center>
          <h2>There are no trends to show.</h2>
        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from "vuex";

export default {
  name: "PolarRadar",
  components: {
    VuePlotly
  },
  props: {
    input_points: {
      type: Array,
      required: true,
    },
    radar_type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      categories: {
        labels: [],
        colors: {
          points: [
            "#f57c00",
            "#0288d1",
            "#d32f2f",
            "#fbc02d",
            "#00796b",
            "#5d4037",
          ]
        },
        areas: [],
        resources: []
      },
      adoptionRanges: {
        "adopt": [0, 3],
        "try": [3, 5],
        "assess": [5, 7]
      },
      date: "",
      options: {
        displayModeBar: false,
        scrollZoom: false,
        responsive: true
      },
      data: [],
      layout: {
        //title: "Entities Web Radar",
        autosize: false,
        //automargin: true,
        margin: {
          l: 0,
          r: 0,
          b: 5,
          t: 5,
          pad: 4
        },
        hovermode: "closest",
        paper_bgcolor: 'rgba(0,0,0,0)',
        showlegend: false,
        polar: {
          angularaxis: {
            visible: false,
            rotation: 90,
            direction: "clockwise"
          },
          radialaxis: {
            visible: false,
            range: [0,8],
            linecolor: "black",
            showgrid: false,
            gridcolor: "black",

            // tickmode: "array",
            // tickval: [2,4,6],
            // ticktext: ["ADOPT", "TRY", "ASSESS"],
            // tickcolor: "black",
          },
          barmode: "overlay",
          bargap: 0,
          gridshape: "grid",
        }
      }
    }
  },
  computed: {
    ...mapGetters("RadarState", {
          tech_labels: "getTechClassesLabels",
          tech_colors: "getTechClassesColors",
          biz_labels: "getBizClassesLabels",
          biz_colors: "getTechClassesColors",
          sources: "getSources",
        }
    ),
  },
  watch: {
    input_points: {
      handler(){
        this.initialize();
        this.onResize();
        this.setPoints(this.input_points)
      },
      deep: true
    },
    radar_type: {
      handler(){
        this.initialize();
        this.onResize();
        this.setPoints(this.input_points)
      },
      deep: true
    }
  },
  mounted() {
    this.initialize();
    this.onResize();
  },
  created() {
    // questa chiamata si può fare anche dall'esterno del componente, per esempio in Radar.vue
    // _this.$refs.polarRadar.setPoints(_this.documents.filter(e => !e.classes.includes('no_classes')));
    this.setPoints(this.input_points);
    console.log(this.input_points)
  },
  methods: {
    initialize() {
      this.categories.labels = (this.radar_type === "tech") ? this.tech_labels : this.biz_labels;
      this.categories.colors.points = (this.radar_type === "tech") ? this.tech_colors : this.biz_colors;
    },
    onResize() {
      let width = this.$refs.vueplotlyContainer.clientWidth;
      this.resize( Math.floor(width*0.95), Math.floor(width*0.75));
    },
    resize(width, height) {
      this.layout.width = width;
      this.layout.height = height;
      this.$refs.vueplotly.relayout(this.layout);
    },
    resetPoints() {
      for (let k = 0; k < this.categories.labels.length; k++) {
        this.categories.resources[k] = [];
      }
    },
    clean() {
      this.data = [];

      // trovo theta min e theta max per ogni classe (360 / il numero di classi * k)
      this.categories.areas = [];
      for (let k = 0; k < this.categories.labels.length; k++) {
        this.categories.areas.push({
          min: (k) * (360 / this.categories.labels.length),
          max: (k + 1) * (360 / this.categories.labels.length)
        });
      }

      // aggiungo al polar chart N barpolar -> un colore diverso per ogni classe
      for (let k = 0; k < this.categories.areas.length; k++){
        this.data.push({
          r: [this.adoptionRanges["assess"][1] + 1],
          theta: [(this.categories.areas[k].max - 30)],
          marker: {color: this.categories.colors.points[k]},
          type: "barpolar",
          width: 60,
          hoverinfo: "skip"
        })
      }

      //aggiungo al polar chart N barpolar -> stesso colore per tutte le classi (ASSESS)
      for (let k = 0; k < this.categories.areas.length; k++){
        this.data.push({
          r: [this.adoptionRanges["assess"][1]],
          theta: [(this.categories.areas[k].max - 30)],
          marker: {color: "rgb(200,200,200)"},
          type: "barpolar",
          width: 58,
          hoverinfo: "skip"
        });
      }

      //aggiungo al polar chart N barpolar -> stesso colore per tutte le classi (TRY)
      for (let k = 0; k < this.categories.areas.length; k++){
        this.data.push({
          r: [this.adoptionRanges["try"][1]],
          theta: [(this.categories.areas[k].max - 30)],
          marker: {color: "rgb(224,224,224)"},
          type: "barpolar",
          width: 58,
          hoverinfo: "skip"
        });
      }

      //aggiungo al polar chart N barpolar -> stesso colore per tutte le classi (ADOPT)
      for (let k = 0; k < this.categories.areas.length; k++){
        this.data.push({
          r: [this.adoptionRanges["adopt"][1]],
          theta: [(this.categories.areas[k].max - 30)],
          marker: {color: "rgb(255,255,255)"},
          type: "barpolar",
          width: 58,
          hoverinfo: "skip"
        });
      }

    },

    setPoints(resources) {
      this.resetPoints();
      this.clean();
      this.addPoints(resources);
    },
    addPoints(resources) {
      console.log("Radar Points", resources);
      for (let resource of resources) {
        if(this.radar_type === "tech"){
          //TECH CATEGORY
          let k = this.categories.labels.findIndex(elem => elem === resource.tech_category);
          this.categories.resources[k].push(resource);
        } else {
          //BIZ CATEGORY
          let ks = [];
          for(let j=0; j<resource.biz_category.length; j++){
            ks.push(this.categories.labels.findIndex(elem => elem === resource.biz_category[j]));
          }
          for(const k of ks){
            this.categories.resources[k].push(resource);
          }
        }
      }
      this.plotPoints();
    },
    plotPoints() {
      for (let k = 0; k < this.categories.labels.length; k++) {
        let serie = {
          type: "scatterpolargl",
          r: [],
          theta: [],
          resources: [],
          //hoverinfo: "title",
          //hovertext: [],
          hovertemplate:
              "<span style='font-weight: 800; font-size: 14px;'>%{text}</span><br>" +
              "<span style='font-size: 14px;'>%{customdata}</span>" +
              "<extra></extra>",
          title: [],
          text: [],
          customdata: [],
          mode: "markers",
          name: this.categories.labels[k].toLowerCase(),
          showlegend: false,
          marker: {
            symbol: [],
            color: this.categories.colors.points[k],
            size: [],
          },
          cliponaxis: false,
        };

        let area = this.categories.areas[k];
        let resources = this.categories.resources[k];

        console.debug("@@@@@@@@", resources.filter(x => x.adoption==="Adopt"))
        console.debug("@@@@@@@@", resources.filter(x => x.adoption==="Try"))
        console.debug("@@@@@@@@", resources.filter(x => x.adoption==="Assess"))

        // calcolo il numero pallini per sezione
        let adopt_num = resources.filter(x => x.adoption==="Adopt").length
        let try_num = resources.filter(x => x.adoption==="Try").length
        let assess_num = resources.filter(x => x.adoption==="Assess").length

        // calcolo il numero di r per ogni sezione
        let adopt_num_r = Math.ceil((resources.filter(x => x.adoption==="Adopt").length/1.5))
        let try_num_r = Math.ceil((resources.filter(x => x.adoption==="Try").length/4))
        let assess_num_r = Math.ceil((resources.filter(x => x.adoption==="Assess").length/6))

        console.debug("@@@@@@@@", adopt_num_r)
        console.debug("@@@@@@@@", try_num_r)
        console.debug("@@@@@@@@", assess_num_r)

        // trovare i valori di r equidistanziati
        let adopt_rs = this.makeArr(0,3,adopt_num_r);
        let try_rs = this.makeArr(3,5,try_num_r);
        let assess_rs = this.makeArr(5,7,assess_num_r);

        console.debug("@@@@@@@@", adopt_rs)
        console.debug("@@@@@@@@", try_rs)
        console.debug("@@@@@@@@", assess_rs)

        // trovare i valori di theta equidistanziati
        let coordinates = {
          "adopt": [],
          "try": [],
          "assess": []
        };
        for(let x of adopt_rs){
          let val_theta = Math.ceil(x);
          if(val_theta > adopt_num) val_theta = adopt_num
          let arr_theta = this.makeArr(area.min, area.max, val_theta);
          for(let y of arr_theta){
            coordinates["adopt"].push({
              "r": x,
              "theta": y
            })
          }
        }
        for(let x of try_rs){
          let val_theta = Math.ceil(x);
          if(val_theta > try_num) val_theta = try_num
          let arr_theta = this.makeArr(area.min, area.max, val_theta);
          for(let y of arr_theta){
            coordinates["try"].push({
              "r": x,
              "theta": y
            })
          }
        }
        for(let x of assess_rs){
          let val_theta = Math.ceil(x);
          if(val_theta > assess_num) val_theta = assess_num
          let arr_theta = this.makeArr(area.min, area.max, val_theta);
          for(let y of arr_theta){
            coordinates["assess"].push({
              "r": x,
              "theta": y
            })
          }
        }

        for (let i = 0; i < resources.length; i++) {
          let percentFromMarginTheta = 0.1; //non deve superare il 50% altrimenti se tolgo 50 da un lato e 50 dall'altro non mi rimane più spazio per plottare
          let percentDownFromMarginR = 0.1;
          let percentUpFromMarginR = 0.1;

          let intervalR = 2;
          let maxR = (this.getMarkerRadius(resources[i].adoption) + 1) - intervalR*percentUpFromMarginR;
          let minR = (this.getMarkerRadius(resources[i].adoption) - 1) + intervalR*percentDownFromMarginR;
          let randomR = (Math.random() * (maxR - minR)) + (minR);

          console.debug("@@@@@@@@", coordinates)
          let coordinate;
          if(this.getMarkerRadius(resources[i].adoption) === 1.5){
            coordinate = coordinates["adopt"].pop()
            console.debug("@@@@@@@@", coordinate)
          } else if (this.getMarkerRadius(resources[i].adoption) === 4){
            coordinate = coordinates["try"].pop()
            console.debug("@@@@@@@@", coordinate)
          } else {
            coordinate = coordinates["assess"].pop()
            console.debug("@@@@@@@@", coordinate)
          }


          let intervalTheta = 60;
          let maxTheta = area.max - intervalTheta*percentFromMarginTheta;
          let minTheta = area.min + intervalTheta*percentFromMarginTheta;
          let randomTheta = Math.random() * (maxTheta - minTheta) + minTheta;

          serie.r.push(coordinate["r"]);
          serie.theta.push(coordinate["theta"]);

          //serie.r.push(randomR);
          //serie.theta.push(randomTheta);
          serie.text.push(resources[i].title);
          serie.customdata.push("<i>Click to see trend details</i>");
          serie.resources.push(resources[i]);

          serie.marker.size.push(this.getMarkerSize(resources[i].business_relevance));
          serie.marker.symbol.push(this.getMarkerSymbol(resources[i].business_impact));
        }
        console.debug("@@@@ Sono uscito dal ciclo for interno")
        this.data.push(serie);
      }

    },
    getMarkerRadius(value){
      if (value.toLowerCase() === "adopt") return 1.5;
      else if (value.toLowerCase() === "try") return 4;
      else if (value.toLowerCase() === "assess") return 6;
      else {
        console.error("Component PolarRadar - getMarkerRadius - " + value + " not correct");
      }
    },
    getMarkerSize(value){
      if (value.toLowerCase() === "low") return 15;
      else if (value.toLowerCase() === "medium") return 20;
      else if (value.toLowerCase() === "high") return 25;
      else {
        console.error("Component PolarRadar - getMarkerSize - " + value + " not correct");
      }
    },
    getMarkerSymbol(value){
      if (value.toLowerCase() === "disruptive") return "triangle-up";
      else if (value.toLowerCase() === "evolutional") return "circle";
      else {
        console.error("Component PolarRadar - getMarkerSymbol - " + value + " not correct");
      }
    },
    openResource(event) {
      let index = event.points[0].pointIndex;
      //console.log("EVENT", event, "INDEX", index);
      //console.log("SELECTED POINT",  event.points[0].data.resources[index]);
      this.$emit("selectedPoint", event.points[0].data.resources[index]);
    },
    makeArr(startValue, stopValue, cardinality) {
      let arr = [];
      let step = (stopValue - startValue) / (cardinality + 1);
      for (let i = 1; i <= cardinality; i++) {
        arr.push(startValue + (step * i));
      }
      return arr;
    }
  }
}
</script>

<style lang="scss">

/*.js-plotly-plot .plotly .main-svg {
    top: -90px!important;
}*/

.vue-plotly {
  .pielayer {
    .surface {
      pointer-events: none !important;
    }
  }
}

.vue-plotly {
  .polarlayer {
    .polar {
      .draglayer {
        .angulardrag {
          display: none;
        }
      }
      /*            .radial-axis {*/
      /*                display: none;*/
      /*            }*/
    }
  }
}
.no-trend-yet{
  height: 300px;
  align-items: center;
}
</style>
